import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

/**
 * @param {object} props
 * @param {import('utils/types').BorderVariant} props.variant
 * @param {import('utils/types').Orientation} props.orientation
 * @param {string} [props.className]
 */
export default function Separator({
  variant = 'solid',
  orientation = 'horizontal',
  className = ''
}) {
  return (
    <div
      data-variant={variant}
      data-orientation={orientation}
      className={cn(styles.container, className)}
    />
  );
}
